import React, { useEffect, useState } from 'react'
import Header from '../../../Components/Header'
import Seo from '../../../Components/SeoComponent/Seo'
import { Button, InputWithLabel } from '../../../Components/Tags/Tags';
import Loader from '../../../Loader';
import { fetchProfile, sendDownloadAadharOtp } from '../../../Services/ApiTestService/aadharTestService';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { Link } from 'react-router-dom';
import { FaDownload, FaIdCard } from 'react-icons/fa';
import { useService } from '../../../context/ServiceContext';
import { IoArrowBackCircleOutline } from "react-icons/io5";
const isValidAadhar = (number) => {
    const regex = /^\d{12}$/;
    return regex.test(number);
};
const AadharDownload = () => {
    const [aadharNumber, setAadharNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [client_id, setClientId] = useState(null);
    const [message, setMessage] = useState({ aadhar: "", otp: "", type: "error" });
    const [profileData, setProfileData] = useState({});
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isAadharVerify, setIsAadharVerify] = useState(false);
    const [aadharData, setAadharData] = useState(null);
    const { serviceName } = useService();
    const handleSubmit = async () => {
        setMessage({ aadhar: '', otp: '', type: 'error' });
      


        if (aadharNumber === "") {
            setMessage({ aadhar: "Aadhar number is required", otp: "", type: 'error' });
            return;
        }

        if (!isValidAadhar(aadharNumber)) {
            setMessage({ aadhar: "Invalid Aadhar number", otp: "", type: 'error' });
            return;
        }
        let payload = {}





        if (!isOtpSent) {
            payload = {

                api_id: profileData?.user_id,
                api_key: profileData?.api_key,
                token_id: profileData?.token_id,
                "aadhar": aadharNumber,
                "methodName": "getotp"

            };
        } else {
            if (!otp || otp.length < 6) {
                setMessage({ aadhar: "", otp: "Enter a valid 6-digit OTP", type: 'error' });
                return;
            }
            payload = {

                api_id: profileData?.user_id,
                api_key: profileData?.api_key,
                token_id: profileData?.token_id,


                "client_id": client_id,
                "otp": otp,
                "methodName": "validateotp"
            };
          
        }



        //1let response = await sendDownloadAadharOtp({ payload: payload });
        // setIsOtpSent(true);
        setIsLoading(true);
        let response = await sendDownloadAadharOtp({ payload: payload });
        setIsLoading(false);
        if (response.status.code === 200) {
            setClientId(response.data.client_id || response.data.data.client_id);
            if (isOtpSent === false) {
                setIsOtpSent(true);
            } else {
                setIsOtpSent(false);
                setIsAadharVerify(true);
                setAadharData(response.data);
                setAadharNumber('')

            }

            showSuccessToast(response?.message)
        } else {
          
            showErrorToast(response?.message || response?.data.message)
        }
    };
    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);
    return (
        <>
            {isLoading && <Loader />}
            <Header heading={serviceName} />
            <Seo title={serviceName} />
            <div>

                <div className="col-span-2 md:col-span-6 flex justify-end">
                    <Link
                        to="/TestMaster"
                        className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
                    >
                        <span>Go Back</span>
                        <IoArrowBackCircleOutline size={24} />
                    </Link>
                </div>
                <div className='flex items-center gap-2 py-2 bg-gray-100 shadow-sm'>


                    <div>
                        <InputWithLabel
                            label={"Aadhar Number"}
                            placeholder={"Enter aadhar number "}
                            required={true}
                            value={aadharNumber}
                            onChange={(e) => setAadharNumber(e.target.value)}
                        />
                        {message.aadhar && (
                            <p className={`text-sm ${message.type === 'error' ? 'text-red-600' : 'text-green-600'}`}>
                                {message.aadhar}
                            </p>
                        )}
                    </div>
                    {isOtpSent && (
                        <div>
                            <InputWithLabel
                                className={'!py-3'}
                                label={"Otp"}
                                input_type={'number'}
                                placeholder={"Enter valid otp "}
                                value={otp}
                                required={true}
                                onChange={(e) => setOtp(e.target.value)}
                            />
                            {message.otp && (
                                <p className={`text-sm ${message.type === 'error' ? 'text-red-600' : 'text-green-600'}`}>
                                    {message.otp}
                                </p>
                            )}
                        </div>
                    )}
                    <div className='mt-4'>
                        <Button type={'button'} text={isOtpSent ? "Verify Otp" : "Send Otp"} onClick={handleSubmit} />
                    </div>

                </div>
                {
                    isAadharVerify && aadharData !== null ?
                        <div className=' bg-white/70 backdrop-blur-lg border border-blue-100 p-6 rounded-2xl shadow-xl max-w-sm '>

                            <p className="flex items-center gap-2">
                                <FaIdCard className="text-indigo-500" />
                                <strong>Aadhar Number:</strong> {aadharData?.aadhaar_number || "N/A"}
                            </p>

                            <Link className='px-3 mx-10 my-2 flex items-center gap-2 py-2 bg-blue-800 rounded-md text-white font-bold' to={aadharData.aadhaar_pdf}><FaDownload /> Download Aadhar</Link>
                        </div>
                        : ""
                }
                <AadhaarInstructions />
            </div>
        </>
    );
};


const AadhaarInstructions = () => {
    return (
        <div className="max-w-5xl mx-auto p-5 bg-white shadow-lg rounded-lg border border-gray-200">
            <h1 className="text-xl font-semibold mb-3 text-red-600 border-b pb-2">Aadhaar PDF Instructions</h1>
            <ol className="list-decimal pl-5 space-y-3 text-gray-700 text-sm">
                <li>
                    <strong>Download:</strong> After downloading your Aadhaar PDF, a password is required to open it.
                </li>
                <li>
                    <strong>Password Format:</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>First 4 letters of your name in UPPERCASE</li>
                        <li>Your birth year (YYYY)</li>
                    </ul>
                    <p className="mt-1 text-sm">
                        <strong>Example:</strong><br />
                        Name: <em>Shiva Kumar</em>, Year: <em>1990</em> →
                        <span className="ml-1 font-mono bg-gray-100 px-2 py-0.5 rounded text-blue-700">SHIV1990</span>
                    </p>
                </li>
                <li>
                    <strong>Important:</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Use only your first name (first four letters)</li>
                        <li>If name has fewer than 4 letters, use the full name</li>
                        <li>No spaces or symbols in the password</li>
                    </ul>
                </li>
                <li>
                    <strong>Having Issues?</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Double-check name and year format</li>
                        <li>Ensure your PDF viewer supports secure files</li>
                    </ul>
                </li>
                <li>
                    <strong>Need Help?</strong> Reach out to support or visit the official Aadhaar help center.
                </li>
            </ol>
        </div>
    );
};



export default AadharDownload
